export enum DealerLastUpdatedActionTypes {
    // Get list
    GET_DEALER_LAST_UPDATED_LIST = "@@dealerLastUpdated/GET_DEALER_LAST_UPDATED_LIST",
    GET_DEALER_LAST_UPDATED_LIST_SUCCESS = "@@dealerLastUpdated/GET_DEALER_LAST_UPDATED_LIST_SUCCESS",
    GET_DEALER_LAST_UPDATED_LIST_FAIL = "@@dealerLastUpdated/GET_DEALER_LAST_UPDATED_LIST_FAIL",

    // Get dealer dropdown
    GET_DEALER_DROPDOWN_LIST = "@@dealerLastUpdated/GET_DEALER_DROPDOWN_LIST",
    GET_DEALER_DROPDOWN_LIST_SUCCESS = "@@dealerLastUpdated/GET_DEALER_DROPDOWN_LIST_SUCCESS",
    GET_DEALER_DROPDOWN_LIST_FAIL = "@@dealerLastUpdated/GET_DEALER_DROPDOWN_LIST_FAIL",

    // Get employee dropdown
    GET_EMPLOYEE_DROPDOWN_LIST = "@@dealerLastUpdated/GET_EMPLOYEE_DROPDOWN_LIST",
    GET_EMPLOYEE_DROPDOWN_LIST_SUCCESS = "@@dealerLastUpdated/GET_EMPLOYEE_DROPDOWN_LIST_SUCCESS",
    GET_EMPLOYEE_DROPDOWN_LIST_FAIL = "@@dealerLastUpdated/GET_EMPLOYEE_DROPDOWN_LIST_FAIL",

    // Get manufacturer dropdown
    GET_MANUFACTURER_DROPDOWN_LIST = "@@dealerLastUpdated/GET_MANUFACTURER_DROPDOWN_LIST",
    GET_MANUFACTURER_DROPDOWN_LIST_SUCCESS = "@@dealerLastUpdated/GET_MANUFACTURER_DROPDOWN_LIST_SUCCESS",
    GET_MANUFACTURER_DROPDOWN_LIST_FAIL = "@@dealerLastUpdated/GET_MANUFACTURER_DROPDOWN_LIST_FAIL",

    // Reset/Clear
    CLEAR_DEALER_LAST_UPDATED_DATA = "@@dealerLastUpdated/CLEAR_DEALER_LAST_UPDATED_DATA",
    CLEAR_DEALER_LAST_UPDATED_MESSAGE = "@@dealerLastUpdated/CLEAR_DEALER_LAST_UPDATED_MESSAGE",
}
